import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import LogoC from "/assets/image/logo.svg";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      errors: {},
    };
  }

  render() {
    const { email, errors } = this.state;

    return (
      <div className="md-login-page">
        <div className="md-login-card">
          <div className="md-login-logo">
            <img src={LogoC} alt="PicSell" />
          </div>

          <div className="md-login-description">
            <p style={{ fontWeight: 600, fontSize: "16px", color: "var(--md-on-surface)", marginBottom: "8px" }}>
              Забули пароль?
            </p>
            <p>
              Введіть свою електронну адресу нижче, і ми надішлемо вам інструкції щодо відновлення пароля.
            </p>
          </div>

          <div className="md-login-field">
            <label>E-mail</label>
            <input
              type="email"
              placeholder="email@example.com"
              value={email}
              onChange={e => this.setState({ email: e.target.value, errors: {} })}
            />
            {errors.email && (
              <span style={{ color: "var(--md-error)", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {errors.email}
              </span>
            )}
          </div>

          <button className="md-login-btn" onClick={this.reset}>
            Відправити
          </button>

          <div className="md-login-back">
            <Link to="/login">← Повернутися до сторінки входу</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  inText: key => state.inText("forgot-password")(key),
}))(ForgotPassword);
